export default __webpack_public_path__ + "static/media/virus.94e85c93.png";